import './NumberOfInvitesLeft.scss';
import { useTranslation } from 'react-i18next';

export const NumberOfInvitesLeft = ({ invitesLeft }: { invitesLeft: number }) => {
  const { t } = useTranslation();

  return (
    <div className='number-of-invites-left'>
      <span>
        <strong>{`${t('NumberOfInvitesLeft', { ns: 'studentsPage' })} ${invitesLeft}`}</strong>
      </span>
    </div>
  );
};
